module.exports = __webpack_public_path__ + "img/business-and-finance.47488ffe.svg";